import { Controller } from "@hotwired/stimulus"

// A subdivision's bedroom rows on its area's page, one bedroom count per
// column: adds up each column's seven season percents as they are typed and
// marks its total red until it is exactly 100. Once it is 100 and the beds
// are set, it submits that column's form, so a column saves itself. A
// column is the inputs that join one form (their form="" attribute), and
// its total cell carries the same id in data-form. The server still refuses
// a row that does not add up.
export default class extends Controller {
  static targets = ["percent", "total", "beds"]

  connect() {
    this.timers = {}
    this.totalTargets.forEach((total) => this.refresh(total.dataset.form))
  }

  disconnect() {
    Object.values(this.timers).forEach(clearTimeout)
  }

  update(event) {
    const formId = event.target.getAttribute("form")
    const off = this.refresh(formId)

    clearTimeout(this.timers[formId])
    const beds = this.bedsTargets.find((input) => input.getAttribute("form") === formId)
    if (off || !beds || beds.value === "") return
    // A pause after the last keystroke, so "12" is one save, not two.
    this.timers[formId] = setTimeout(() => document.getElementById(formId)?.requestSubmit(), 500)
  }

  // Writes the column's total and returns whether it is off 100.
  refresh(formId) {
    // Whole hundredths, so 33.33 + 33.33 + 33.34 is exactly 100.
    const hundredths = this.percentTargets
      .filter((input) => input.getAttribute("form") === formId)
      .reduce((sum, input) => sum + Math.round((parseFloat(input.value) || 0) * 100), 0)
    const off = hundredths !== 10000
    const total = this.totalTargets.find((cell) => cell.dataset.form === formId)
    if (total) {
      total.textContent = `${(hundredths / 100).toFixed(2).replace(/\.00$/, "")}%`
      total.classList.toggle("text-bad", off)
      total.classList.toggle("text-good", !off)
    }
    return off
  }
}
